type Truthy<T> = T extends false | '' | 0 | null | undefined ? never : T;

type Nullish<T> = T extends null | undefined ? T : never;

type NotNullish<T> = T extends null | undefined ? never : T;

export function isTruthy<T>(value: T): value is Truthy<T> {
  return !!value;
}

export function isNullish<T>(value: T): value is Nullish<T> {
  return typeof value === 'undefined' || value === null;
}

export function isNotNullish<T>(value: T): value is NotNullish<T> {
  return !isNullish(value);
}
